/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { removeOption, deleteContent } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import Delete from 'material/embeds/content/edit/delete/delete';



/* ========== ~~~~~~~~~~ EMBED : EDIT : DELETE : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }, { contentId }) => ({
    numberOfOptions: Object.keys(embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['options']).length,
});
const mapDispatchToProps = dispatch => ({
    removeOption: (contentId, optionId) => dispatch(removeOption(contentId, optionId)),
    deleteContent: contentId => dispatch(deleteContent(contentId))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Delete);
